import { SdkThunkActionResult } from "@payping/redux/reducers";

import { SET_REDIRECT_URL } from "../reducers/loginRedirect";

export function setRedirectUrl(url: string): SdkThunkActionResult<Promise<void>> {
  return async (dispatch): Promise<void> => {
    dispatch({ payload: url, type: SET_REDIRECT_URL });
  };
}
